import { QueryClient } from '@tanstack/query-core';

export const globalQueryClient = new QueryClient({ defaultOptions: { queries: { experimental_prefetchInRender: true } } });

export function getGlobalQueryClient() {
  return globalQueryClient;
}
